export const carouselPrimaryCard = {
  open: {
    top: '50%',
    opacity: 1,
    left: 0,
    transform: 'translateY(-50%) scale(1)',
  },
  exit: {
    left: '-20%',
    transform: 'translateY(-50%) scale(1)',
    top: '50%',
    opacity: 0,
  },
};

export const carouselSecondaryCard = {
  open: {
    top: '50%',
    opacity: 1,
    left: '10%',
    transform: 'translateY(-50%) scale(0.95)',
  },
  exit: {
    left: 0,
    transform: 'translateY(-50%) scale(1)',
    top: '50%',
    opacity: 0,
  },
};

export const carouselTertiaryCard = {
  open: {
    top: '50%',
    opacity: 1,
    left: '20%',
    transform: 'translateY(-50%) scale(0.9)',
  },
  exit: {
    top: '50%',
    opacity: 0,
    left: '10%',
    transform: 'translateY(-50%) scale(0.95)',
  },
};

export const carouselTransition = {
  ease: 'easeInOut',
  duration: 0.25,
};
